<template>
  <img v-if="img" class="icon" :style="imgStyle" :src="require('assets/icon/svg/' + name + '.svg')" alt="" />
  <i v-else class="icon" :style="iconStyle" @click="$emit('click', $event)" />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    size: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    img: Boolean,
  },
  emits: ['click'],
  computed: {
    iconStyle() {
      const height = this.size || this.height
      const width = this.size || this.width
      try {
        const maskImage = `url(${require(`assets/icon/svg/${this.name}.svg`)})`
        const result = {
          '-webkit-mask-image': maskImage,
          'mask-image': maskImage,
          background: this.color,
        }
        if (height) {
          result.height = `${height}px`
        }
        if (width) {
          result.width = `${width}px`
        }
        return result
      } catch {
        console.error(`Could not load icon '${this.name}'`)
        return {
          height: `${this.height}px`,
          width: `${this.width}px`,
        }
      }
    },

    imgStyle() {
      return {
        height: `${this.size || this.height}px`,
        width: `${this.size || this.width}px`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}
</style>
